import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Result
        status="403"
        title="403"
        subTitle="Nemate dozvolu za pristup ovoj stranici."
        extra={
          <Button type="primary" onClick={() => navigate('/login')}>
            Vrati se na prijavu
          </Button>
        }
      />
    </div>
  );
};

export default Unauthorized;
